import styled from 'styled-components';
import { Layout } from 'antd';

export type HeaderProps = { src: string | undefined; alt?: string };

export const StyledBannerContainer = styled(Layout)`
  height: auto;
  background: none;
  padding: 0;
`;

const Image =
    styled.img.attrs<HeaderProps>((props: HeaderProps) => ({
      src: props.src,
      alt: props.alt ?? '',
    }))`
    display: block;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    vertical-align: top;
    border-style: solid;
    max-width: 100%;
    border-width: 0;
    border-color: #9c9c9c;
`;

export default Image;
